export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8328.1e649b30.jpg";